<template>
    <TotemButton
        icon="add"
        color="primary"
        @click="loadMore"
        v-if="hasMoreResults"
        :label="$t('General.load_more')"
    />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
    export default {
        name: 'LoadMore',
        computed: {
            ...mapGetters({
                hasMoreResults: 'Search/hasMoreResults'
            })
        },
        methods: {
            ...mapActions({
                loadMore: 'Search/doSearchNow'
            })
        }
    }
</script>

<style scoped>

</style>
